import { render, staticRenderFns } from "./TrainingItemInformation.vue?vue&type=template&id=4fc33cc6&scoped=true&"
import script from "./TrainingItemInformation.vue?vue&type=script&lang=js&"
export * from "./TrainingItemInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc33cc6",
  null
  
)

export default component.exports